import PageLayout from "@/components/feature/PageLayout";
import { Link } from "react-router-dom";

export default function NoProductPage() {
  return (
    <PageLayout>
      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="mb-1">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Subscription Management</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">What if I never received the product or service?</h2>
        <div className="space-y-4 text-sm">
          <p className="text-gray-500">
            We&apos;re sorry to hear you didn&apos;t receive what you paid for. This is a priority issue for us and we&apos;ll work to resolve it as quickly as possible.
          </p>
          <h4 className="font-semibold text-gray-800">Steps to take:</h4>
          <ol className="list-decimal list-inside space-y-2 text-gray-500">
            <li>Check your spam/junk folder for any delivery emails</li>
            <li>Verify the email address used during sign-up</li>
            <li>Contact our support team with your order details</li>
            <li>If unresolved, submit a formal dispute using the form below</li>
          </ol>
          <h4 className="font-semibold text-gray-800">What we will do:</h4>
          <ul className="list-disc list-inside space-y-2 text-gray-500">
            <li>Investigate your order within 1–2 business days</li>
            <li>Re-deliver the product or service if applicable</li>
            <li>Issue a full refund if delivery cannot be confirmed</li>
          </ul>
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <p className="text-sm text-gray-500">
              <strong className="text-gray-700">Important:</strong> Please have your order confirmation number or transaction ID ready when contacting us — it helps us resolve your case faster.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
          <Link to="/contact-support" className="inline-block bg-[#2d2f36] text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-center">
            Contact Support
          </Link>
          <Link to="/dispute-resolution" className="inline-block border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center">
            Submit a Dispute Form
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
